import { render, staticRenderFns } from "./CaseTemplateSectionMenu.vue?vue&type=template&id=e3a84814&scoped=true"
import script from "./CaseTemplateSectionMenu.vue?vue&type=script&lang=js"
export * from "./CaseTemplateSectionMenu.vue?vue&type=script&lang=js"
import style0 from "./CaseTemplateSectionMenu.vue?vue&type=style&index=0&id=e3a84814&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a84814",
  null
  
)

export default component.exports